import dayjs from "dayjs";

// Pure helpers shared by every reschedule surface (Mis reservas, guest manage link, organizer).

/** The API wraps payloads as `{ info }` most of the time; accept a bare body too. */
export const unwrap = (res) => res?.data?.info ?? res?.data ?? null;

// `codigo` values the back can answer with (400 unless noted; slot_taken is a 409).
const MESSAGES = {
  reschedule_not_allowed: "Este turno no se puede reagendar.",
  deadline_passed: "Ya pasó el plazo para reagendar este turno.",
  limit_reached: "Ya usaste todos los reagendamientos disponibles para este turno.",
  already_paid_at_pos: "Este turno ya se pagó en el local y no se puede reagendar.",
  invalid_slot: "Ese horario ya no es válido. Elegí otro.",
  slot_taken: "Ese horario se acaba de ocupar. Elegí otro.",
};

export const SLOT_TAKEN = "slot_taken";

export const rescheduleCode = (error) => {
  const data = error?.response?.data;
  if (data?.codigo) return data.codigo;
  if (error?.response?.status === 409) return SLOT_TAKEN;
  return "";
};

/** Friendly Spanish message for a failed reschedule call. */
export const rescheduleErrorMessage = (error, fallback = "No pudimos reagendar el turno. Probá de nuevo.") =>
  MESSAGES[rescheduleCode(error)] || fallback;

/** Message for the `reason` of a reschedule-options answer with `allowed: false`. */
export const reasonMessage = (reason) => MESSAGES[reason] || MESSAGES.reschedule_not_allowed;

/** "Te quedan 2 reagendamientos" (empty when the back sent no number). */
export const remainingLabel = (remaining) => {
  const n = Number(remaining);
  if (remaining == null || !Number.isFinite(n) || n < 0) return "";
  if (n === 0) return "No te quedan reagendamientos";
  return `Te quedan ${n} ${n === 1 ? "reagendamiento" : "reagendamientos"}`;
};

/** "Podés reagendar hasta el 12/10 a las 14:30" (empty when there is no valid deadline). */
export const deadlineLabel = (deadline) => {
  const d = deadline ? dayjs(deadline) : null;
  if (!d || !d.isValid()) return "";
  return `Podés reagendar hasta el ${d.format("DD/MM")} a las ${d.format("HH:mm")}`;
};
